import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import { setScrollLocked } from "../../lib/motion";

const FooterModal = ({ show, onHide, title, children }) => {
  /* Bootstrap locks the body, but Lenis drives its own scroll position and
     would happily keep moving the page underneath the dialog. */
  useEffect(() => {
    setScrollLocked(show);
    return () => setScrollLocked(false);
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} centered size="lg" scrollable>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn-sales btn-sales--sm" onClick={onHide}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default FooterModal;
